"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

// Namespaces Dispatch Actions to an actions object
var _default = function _default(stateProps, dispatchProps, ownProps) {
  return (0, _extends2["default"])({}, ownProps, stateProps, {
    actions: (0, _extends2["default"])({}, dispatchProps, ownProps.actions)
  });
};

exports["default"] = _default;